/** HTTP response status indicating a successful API call. */
export const SUCCESS_STATUS = 1;

/** HTTP response status indicating a failed API call. */
export const ERROR_STATUS = 0;

/**
 * Supported HTTP methods for API requests.
 * @constant
 * @type {Object<string, string>}
 */
export const QUERY_METHODS = {
    POST: 'POST',
};

/**
 * Request type values for params cloud API call.
 * @constant
 * @type {Object<string, string>}
 */
export const REQUEST_PARAMS_TYPE = {
    DELETE: 'delete',
};

/**
 * An enumeration of different API call names.
 *
 * @constant
 * @type {Object<string, string>}
 */
export const CALLS = {
    LEGACY_SEND_NEW_USER_INFO_TO_USER: 'legacy_send_new_user_info_to_user',
    LEGACY_ID_MAPPING: 'legacy_id_mapping',
    USER_REQUEST: 'user_request',
    integrations_list: 'integrations_list',
    integrations_preview: 'integrations_preview',
};
